import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutMe } from './components/AboutMe';
import { WhoIHelp } from './components/WhoIHelp';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-offwhite-50 font-sans selection:bg-amber-500/30 selection:text-charcoal-950" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutMe data-id="element-4" />
        <WhoIHelp data-id="element-5" />
        <Approach data-id="element-6" />
        <Services data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}